import React from 'react';
import Helmet from 'react-helmet';
import FontLoader from '../components/font-loader';
import Header from '../components/header';
import Footer from '../components/footer';

import '../pages/index.scss';

const Meta = () => {
    return (
        <Helmet
            title="The Farm Project – by Zooey Deschanel & Jacob Pechenik"
            meta={[
                {
                    name: 'description',
                    content:
                        'The Farm Project was founded by Zooey Deschanel and Jacob Pechenik with the mission to reconnect people with food.',
                },
                {
                    name: 'keywords',
                    content: 'organic, food, farm, local, community, people',
                },
                {
                    name: 'title',
                    content: 'The Farm Project – by Zooey Deschanel & Jacob Pechenik',
                },
            ]}
        />
    );
};

const IndexLayout = props => {
    return (
        <div className="content">
            <Meta />
            <FontLoader />
            <Header key={props.location.pathname} location={{ pathname: props.location.pathname }} />
            {props.children()}
            <Footer />
        </div>
    );
};

export default IndexLayout;



// WEBPACK FOOTER //
// ./src/layouts/index.js